import { JSONAPISerializer } from '@warp-drive/legacy/serializer/json-api';
import { camelize } from '@warp-drive/utilities/string';

export default class extends JSONAPISerializer {
  keyForAttribute(attr: string) {
    return camelize(attr);
  }

  keyForRelationship(key: string) {
    return camelize(key);
  }
}
